/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.scss'],
    imports: [NgIf, MatDialogModule, MatIconModule]
})
export class SessionTimeoutComponent implements OnInit {
  @Output() successEvent = new EventEmitter();
  @Output() cancel = new EventEmitter();
  buttonText: string = 'CONTINUE';
  dialogContent!: string;
  dialogData: any;
  dialogMessage: any;
  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data$: BehaviorSubject<any>,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.onSubscribe();
  }

  onSubscribe(): void {
    let setDelay: any;
    this.data$.subscribe((data: any) => {
      if (data) {
        this.dialogContent = this.domSanitizer.bypassSecurityTrustHtml(data.message as string) as string;
        this.dialogData = data;
        let delay = data.delay;
        this.dialogMessage = data.message.replace('{{delay}}', delay);
        if (data.action === 'CONTINUE_SESSION') {
          setDelay = setInterval(() => {
            this.dialogMessage = data.message.replace('{{delay}}', --delay);
          }, 1000);
        } else {
          clearInterval(setDelay as number);
        }
      }
    });
  }

  dialogSuccess(data: any): void {
    this.successEvent.emit(data);
  }

  dialogCancel(data: any): void {
    this.cancel.emit(data);
  }
}
